exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cat-item a[data-v-5921a017] {\n  text-decoration: none;\n}\n.no-task[data-v-5921a017] {\n  display: none;\n}", ""]);

// exports
